import React from 'react';
import { Card } from '@/components/ui/card';

export const SkeletonCard = () => (
  <Card className="p-6 bg-white border border-[#E2E8F0] rounded-md animate-pulse">
    <div className="h-4 bg-[#E2E8F0] rounded w-3/4 mb-4" />
    <div className="h-3 bg-[#E2E8F0] rounded w-1/2 mb-3" />
    <div className="h-3 bg-[#E2E8F0] rounded w-2/3" />
  </Card>
);

export const SkeletonList = ({ count = 3 }) => (
  <div className="space-y-4" data-testid="loading-skeleton">
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonCard key={i} />
    ))}
  </div>
);

export const SkeletonProfile = () => (
  <div className="space-y-6 animate-pulse" data-testid="loading-profile">
    <Card className="p-8 bg-white border border-[#E2E8F0] rounded-md">
      <div className="flex items-center gap-6">
        <div className="w-20 h-20 bg-[#E2E8F0] rounded-full" />
        <div className="flex-1">
          <div className="h-6 bg-[#E2E8F0] rounded w-1/3 mb-3" />
          <div className="h-4 bg-[#E2E8F0] rounded w-1/4" />
        </div>
        <div className="w-32 h-32 bg-[#E2E8F0] rounded-full" />
      </div>
    </Card>
    <Card className="p-6 bg-white border border-[#E2E8F0] rounded-md">
      <div className="h-4 bg-[#E2E8F0] rounded w-full mb-3" />
      <div className="h-4 bg-[#E2E8F0] rounded w-5/6 mb-3" />
      <div className="h-4 bg-[#E2E8F0] rounded w-4/6" />
    </Card>
  </div>
);
